import { createIdentifier } from '@blocksuite/global/di';
import type { ExtensionType } from '@blocksuite/store';

export type MermaidExternalAction =
  | 'modify-ai'
  | 'repair-ai'
  | 'copy-svg'
  | 'export-svg'
  | 'export-png';

export type MermaidActionInput = {
  elementId: string;
  source: string;
};

export interface MermaidActionService {
  can(action: MermaidExternalAction, input: MermaidActionInput): boolean;
  run(
    action: MermaidExternalAction,
    input: MermaidActionInput
  ): Promise<void> | void;
}

export const MermaidActionProvider = createIdentifier<MermaidActionService>(
  'AffineMermaidActionProvider'
);

export function MermaidActionExtension(
  service: MermaidActionService
): ExtensionType {
  return {
    setup: di => {
      di.addImpl(MermaidActionProvider, () => service);
    },
  };
}
